import React from "react";
import { DatePicker } from "antd";
import moment from "moment";

const DatepickerComponent = (props) => {

  const defaultDisabledDate = (current) => {
    return current > moment.now();
  }

  return (
    <div className="date-picker-custom">
      <label style={{ width: "100%" }}>
        <span>
          {props.controlLabel}
          {props.required && "*"}
        </span>
        <DatePicker
          getPopupContainer={(trigger) => trigger.parentNode}
          disabledDate={props.disabledDate ? props.disabledDate : defaultDisabledDate}
          onChange={(date, dateString) =>
            props.handleDayClick(date, dateString, props.index)
          }
          format="DD.MM.YYYY"
          style={{
            width: props.width,
            borderColor: props.errorBorderColor,
            // zIndex: "9999999!important",
          }}
          defaultValue={
            props.value ? moment(props.value, "DD.MM.YYYY") : props.value
          }
          disabled={props.disabled}
        />
      </label>
    </div>
  );
};

export default DatepickerComponent;
